var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import CampaignFormMessageSettings from "./CampaignFormMessageSettings";
import CampaignFormMessageContent from "./CampaignFormMessageContent";
import CampaignFormAppointmentAction from "./CampaignFormAppointmentAction";
import CampaignActionDomainService from "../../../../Domain/CampaignAction/CampaignAction.service";
import useTabs from "../../../Hooks/useTabs";
import { AlertError, AlertInfo, } from "../../../UI/StandardAlerts/StandardAlerts";
import DateService from "../../../../Services/Shared/Date.service";
import AutomatedScheduleDomainService from "../../../../Domain/AutomatedSchedule/AutomatedSchedule.service";
import CampaignSendBehaviorDomainService from "../../../../Domain/CampaignSendBehavior/CampaignSendBehavior.service";
import { getFromEmailAddressCampaignFromAddressFromFromEmailAddress, getPersonCampaignFromAddressFromPerson, } from "../../../../Services/Message.service";
import CampaignService from "../../../../Services/Campaign.service";
import useService from "../../../Hooks/useService";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import CampaignFormApplicationAction from "./CampaignFormApplicationAction";
import CampaignFormEnrollmentAction from "./CampaignFormEnrollmentAction";
const campaignToInternal = ({ campaign, caseloadPeople, }) => {
    var _a, _b;
    return {
        simpleBody: campaign.simpleBody,
        htmlBody: campaign.htmlBody,
        template: campaign.templateDefinitionComponents,
        templateStyles: campaign.templateDefinitionStyles,
        subject: campaign.message.subject,
        name: campaign.name,
        from: campaign.fromEmailAddress
            ? getFromEmailAddressCampaignFromAddressFromFromEmailAddress(campaign.fromEmailAddress)
            : getPersonCampaignFromAddressFromPerson(campaign.sender),
        population: campaign.population,
        populationAdHocCaseloads: caseloadPeople,
        useSimpleEditor: campaign.useSimpleEditor ? "true" : "false",
        useInstitutionalEmail: campaign.sendToInstitutionalEmail ? "true" : "false",
        templateAssets: campaign.templateDefinitionAssets,
        automatedSchedule: campaign.automatedSchedule,
        sendDate: ((_a = campaign.automatedSchedule) === null || _a === void 0 ? void 0 : _a.startDate)
            ? moment(campaign.automatedSchedule.startDate)
            : null,
        sendDateTime: (_b = campaign.automatedSchedule) === null || _b === void 0 ? void 0 : _b.startDate,
        sendBehavior: campaign.sendBehavior.id ===
            CampaignSendBehaviorDomainService.SendOnStart.id
            ? "manual"
            : "scheduled",
        isOngoing: campaign.sendBehavior.id ===
            CampaignSendBehaviorDomainService.SendOngoing.id,
        campaignTemplateId: campaign.campaignTemplateId,
        inDragAndDropMode: campaign.isDragAndDrop ? "true" : "false",
        virtualizedAppName: campaign.virtualizedAppName,
    };
};
export const campaignToFormState = ({ campaign, caseloadPeople, }) => {
    switch (campaign.campaignTypeId) {
        case CampaignActionDomainService.AppointmentId: {
            const formState = Object.assign(Object.assign({}, campaignToInternal({
                campaign,
                caseloadPeople,
            })), { advisors: campaign.staffPeople, meetingTypes: campaign.meetingTypes, locations: campaign.locations, serviceOfferings: campaign.serviceOfferings, startDate: campaign.startDate, endDate: campaign.endDate, overrideTaskTitle: campaign.overrideTaskTitle, overrideTaskDescription: campaign.overrideTaskDescription, campaignActionId: CampaignActionDomainService.AppointmentId, createTask: campaign.createTask });
            return formState;
        }
        case CampaignActionDomainService.EnrollmentId: {
            const formState = Object.assign(Object.assign({}, campaignToInternal({
                campaign,
                caseloadPeople,
            })), { departments: campaign.departments, courseSections: campaign.courseSections, courses: campaign.courses, academicCalendars: campaign.academicCalendars, transcriptCourseStatuses: campaign.transcriptCourseStatuses, campaignActionId: CampaignActionDomainService.EnrollmentId, overrideTaskTitle: campaign.overrideTaskTitle, overrideTaskDescription: campaign.overrideTaskDescription, createTask: campaign.createTask });
            return formState;
        }
        case CampaignActionDomainService.ApplicationId: {
            const formState = Object.assign(Object.assign({}, campaignToInternal({
                campaign,
                caseloadPeople,
            })), { applicationStatuses: campaign.applicationStatuses, academicCalendars: campaign.academicCalendars, programs: campaign.programs, campaignActionId: CampaignActionDomainService.ApplicationId, overrideTaskTitle: campaign.overrideTaskTitle, overrideTaskDescription: campaign.overrideTaskDescription, createTask: campaign.createTask });
            return formState;
        }
        case CampaignActionDomainService.GeneralId:
        default: {
            const formState = Object.assign(Object.assign({}, campaignToInternal({
                campaign,
                caseloadPeople,
            })), { campaignActionId: CampaignActionDomainService.GeneralId });
            return formState;
        }
    }
};
export const parseCampaignRequest = (formState) => {
    const sendDate = formState.sendDate
        ? DateService.getDateWithTime(formState.sendDate.toDate(), formState.sendDateTime)
        : null;
    let sendBehavior = CampaignSendBehaviorDomainService.SendOnStart.id;
    if (formState.sendBehavior === "scheduled") {
        sendBehavior = formState.isOngoing
            ? CampaignSendBehaviorDomainService.SendOngoing.id
            : CampaignSendBehaviorDomainService.SendOnDate.id;
    }
    let automatedSchedule = null;
    switch (sendBehavior) {
        case CampaignSendBehaviorDomainService.SendOngoing.id:
            automatedSchedule = formState.automatedSchedule;
            break;
        case CampaignSendBehaviorDomainService.SendOnDate.id:
            automatedSchedule =
                AutomatedScheduleDomainService.getOneTimeRRuleSchedule(sendDate);
            break;
        default:
        // do nothing
    }
    return {
        message: {
            populationId: formState.population.id,
            populationAdHocCaseloadAffiliationIds: formState.populationAdHocCaseloads.map((personLite) => personLite.affiliationId),
            simpleBody: formState.simpleBody,
            htmlBody: formState.htmlBody,
            sendToInstitutional: formState.useInstitutionalEmail === "true",
            sendToPersonal: formState.useInstitutionalEmail !== "true",
            subject: formState.subject,
            from: {
                type: formState.from.type,
                id: formState.from.id,
            },
            templateComponents: formState.template,
            templateAssets: formState.templateAssets,
            templateStyles: formState.templateStyles,
            useSimpleEditor: formState.useSimpleEditor === "true",
            isDragAndDrop: formState.inDragAndDropMode === "true",
        },
        campaignTemplateId: formState.campaignTemplateId,
        sendDate,
        automatedSchedule,
        sendBehavior,
        name: formState.name,
        id: formState.id ? formState.id : null,
        virtualizedAppName: formState.virtualizedAppName,
    };
};
const _campaignFormStateToRequest = (formState) => {
    switch (formState.campaignActionId) {
        case CampaignActionDomainService.AppointmentId: {
            const _a = formState, { advisors, meetingTypes, locations, serviceOfferings, startDate, endDate, overrideTaskTitle, overrideTaskDescription, createTask } = _a, otherStuff = __rest(_a, ["advisors", "meetingTypes", "locations", "serviceOfferings", "startDate", "endDate", "overrideTaskTitle", "overrideTaskDescription", "createTask"]);
            const request = Object.assign(Object.assign({}, parseCampaignRequest(otherStuff)), { action: {
                    id: CampaignActionDomainService.AppointmentId,
                    advisorIds: advisors === null || advisors === void 0 ? void 0 : advisors.map((ad) => ad.personId),
                    meetingTypeIds: meetingTypes === null || meetingTypes === void 0 ? void 0 : meetingTypes.map((m) => m.id),
                    serviceOfferingIds: serviceOfferings === null || serviceOfferings === void 0 ? void 0 : serviceOfferings.map((so) => so.id),
                    locationIds: locations === null || locations === void 0 ? void 0 : locations.map((l) => l.id),
                    overrideTaskTitle,
                    overrideTaskDescription,
                    startDate,
                    endDate,
                    createTask,
                } });
            return request;
        }
        case CampaignActionDomainService.ApplicationId: {
            const _b = formState, { applicationStatuses, academicCalendars, programs, overrideTaskTitle, overrideTaskDescription, createTask } = _b, otherStuff = __rest(_b, ["applicationStatuses", "academicCalendars", "programs", "overrideTaskTitle", "overrideTaskDescription", "createTask"]);
            const request = Object.assign(Object.assign({}, parseCampaignRequest(otherStuff)), { action: {
                    id: CampaignActionDomainService.ApplicationId,
                    applicationStatusIds: applicationStatuses === null || applicationStatuses === void 0 ? void 0 : applicationStatuses.map((pas) => pas.id).map((n) => parseInt(n, 10)),
                    academicCalendarIds: academicCalendars === null || academicCalendars === void 0 ? void 0 : academicCalendars.map((ac) => ac.id),
                    programIds: programs === null || programs === void 0 ? void 0 : programs.map((p) => p.id),
                    overrideTaskTitle,
                    overrideTaskDescription,
                    createTask: createTask !== null && createTask !== void 0 ? createTask : false,
                } });
            return request;
        }
        case CampaignActionDomainService.EnrollmentId: {
            const _c = formState, { departments, courseSections, courses, academicCalendars, transcriptCourseStatuses, overrideTaskTitle, overrideTaskDescription, createTask } = _c, otherStuff = __rest(_c, ["departments", "courseSections", "courses", "academicCalendars", "transcriptCourseStatuses", "overrideTaskTitle", "overrideTaskDescription", "createTask"]);
            const request = Object.assign(Object.assign({}, parseCampaignRequest(otherStuff)), { action: {
                    id: CampaignActionDomainService.EnrollmentId,
                    academicCalendarIds: academicCalendars === null || academicCalendars === void 0 ? void 0 : academicCalendars.map((ac) => ac.id),
                    departmentIds: departments === null || departments === void 0 ? void 0 : departments.map((d) => d.id),
                    courseSectionIds: courseSections === null || courseSections === void 0 ? void 0 : courseSections.map((cs) => cs.id),
                    courseIds: courses === null || courses === void 0 ? void 0 : courses.map((c) => c.id.toString()),
                    transcriptCourseStatusIds: transcriptCourseStatuses === null || transcriptCourseStatuses === void 0 ? void 0 : transcriptCourseStatuses.map((tcs) => tcs.id),
                    overrideTaskTitle,
                    overrideTaskDescription,
                    createTask,
                } });
            return request;
        }
        case CampaignActionDomainService.GeneralId:
        default: {
            const request = Object.assign(Object.assign({}, parseCampaignRequest(formState)), { action: { id: CampaignActionDomainService.GeneralId } });
            return request;
        }
    }
};
export const campaignFormStateToRequest = (formState) => // We use this internal function because the valueAsNumber function in react-hook-form isn't working, so we
 
// need to parse campaignActionId as a number.
_campaignFormStateToRequest(Object.assign(Object.assign({}, formState), { campaignActionId: parseInt(
    // @ts-expect-error This might already be a number, but we'll convert it just in case.
    formState.campaignActionId, 10) }));
const CampaignForm = (_a) => {
    var _b;
    var { actionId, campaignId, populationsToAddAsOptions } = _a, formProps = __rest(_a, ["actionId", "campaignId", "populationsToAddAsOptions"]);
    const GENERAL_SETTINGS_HELP_TEXT = "Select the criteria that will complete the campaign for each individual. Leaving it blank means that any value will be accepted as meeting the criteria.";
    const ACTION_TAB_MAP = {
        [CampaignActionDomainService.AppointmentId]: {
            tab: "Appointment Settings",
            content: (_jsxs("div", { children: [_jsx(AlertInfo, { message: GENERAL_SETTINGS_HELP_TEXT }), _jsx(CampaignFormAppointmentAction, Object.assign({}, formProps))] })),
        },
        [CampaignActionDomainService.ApplicationId]: {
            tab: "Application Settings",
            content: (_jsxs("div", { children: [_jsx(AlertInfo, { message: GENERAL_SETTINGS_HELP_TEXT }), _jsx(CampaignFormApplicationAction, {})] })),
        },
        [CampaignActionDomainService.EnrollmentId]: {
            tab: "Enrollment Settings",
            content: (_jsxs("div", { children: [_jsx(AlertInfo, { message: GENERAL_SETTINGS_HELP_TEXT }), _jsx(CampaignFormEnrollmentAction, Object.assign({}, formProps))] })),
        },
    };
    const [campaignTypeState, loadCampaignType] = useService(CampaignService.getAction);
    React.useEffect(() => {
        loadCampaignType(actionId);
    }, [actionId, loadCampaignType]);
    const [tabs, content] = useTabs({
        keepAllTabsMounted: true,
        enableRouting: "campaignForm",
        tabs: [
            {
                tab: "Settings",
                content: (_jsx(CampaignFormMessageSettings, { populationsToAddAsOptions: populationsToAddAsOptions })),
            },
            {
                tab: "Content",
                // eslint-disable-next-line react/display-name
                content: (active) => (_jsx(ServiceResult, { state: campaignTypeState, children: (campaignType) => (_jsx(CampaignFormMessageContent, Object.assign({}, formProps, { hideEditor: !active, campaignType: campaignType, register: formProps.register }))) })),
            },
            ACTION_TAB_MAP[actionId],
        ],
        tabStyle: "underline",
    });
    const { setValue } = formProps;
    React.useEffect(() => {
        setValue("id", campaignId);
        setValue("campaignActionId", actionId);
    }, [actionId, campaignId, formProps, setValue]);
    return (_jsxs(_Fragment, { children: [((_b = Object.keys(formProps.errors)) === null || _b === void 0 ? void 0 : _b.length) > 0 && (_jsx(AlertError, { message: _jsx("ul", { className: "mb-0", children: Object.values(formProps.errors)
                        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                        .map((error) => error.message)
                        .filter((message) => message)
                        .map((message, i) => (_jsx("li", { children: message }, i))) }) })), tabs, _jsxs("div", { className: "w-100 mt-3", style: { height: "100%" }, children: [_jsx("input", { type: "hidden", name: "campaignActionId", ref: formProps.register }), _jsx("input", { type: "hidden", name: "id", ref: formProps.register }), _jsx("input", { type: "hidden", name: "virtualizedAppName", ref: formProps.register }), content] })] }));
};
export default CampaignForm;
